import React from 'react';
const IconMiscTextLong = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 5H12V7H21V5Z" fill="#2D2E2E"/>
<path d="M21 11H12V13H21V11Z" fill="#2D2E2E"/>
<path d="M21 17H12V19H21V17Z" fill="#2D2E2E"/>
<path fillRule="evenodd" clipRule="evenodd" d="M6.5 9.9375L9 9.9375V7.9375H2V9.9375L4.5 9.9375V17H6.5V9.9375Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscTextLong;